import { ResponseStatus } from '../../common/Interfaces';
import { LoggingService } from '../services/logging';
const log = new LoggingService();
export function getStatusIcon(
    status,
    message = ''
): {
    isMaterial: boolean;
    isFontawesome: boolean;
    isFASpinner: boolean;
    icon: string;
    isSuccess: boolean;
    isAccent: boolean;
    isWarning: boolean;
    isError: boolean;
    iconText: string;
} {
    const statusNumber = Number(status);
    const result = {
        isMaterial: false,
        isFontawesome: false,
        isFASpinner: false,
        icon: '',
        isSuccess: false,
        isAccent: false,
        isWarning: false,
        isError: false,
        iconText: ''
    };

    result.isMaterial = false;
    result.isFontawesome = false;
    result.isFASpinner = false;

    result.icon = '';
    result.isSuccess = false;
    result.isWarning = false;
    result.isError = false;
    switch (statusNumber) {
        case ResponseStatus.Success:
            result.isMaterial = true;
            result.icon = 'check_circle';
            result.iconText = 'pi pi-check-circle';
            result.isSuccess = true;
            break;
        case ResponseStatus.Warning:
            result.isMaterial = true;
            result.icon = 'report_problem';
            result.iconText = 'pi pi-exclamation-triangle';
            result.isWarning = true;
            break;
        case ResponseStatus.ClientError:
        case ResponseStatus.Failed:
            result.isMaterial = true;
            result.icon = 'cancel';
            result.iconText = 'pi pi-times-circle';
            result.isError = true;
            break;
        case ResponseStatus.ConcurrencyViolation:
        case ResponseStatus.PartialSuccess:
        case ResponseStatus.LoginExpired:
            result.isMaterial = true;
            result.icon = 'highlight_off';
            result.isError = true;
            break;
        case ResponseStatus.Loading:
            result.isFontawesome = true;
            result.isFASpinner = true;
            break;
        case ResponseStatus.Adding:
            result.isMaterial = true;
            result.icon = 'add_circle';
            result.isAccent = true;
            break;
        default:
            result.iconText = '<div />';
            result.isError = false;
            result.isWarning = false;
            result.isSuccess = false;
            result.isMaterial = false;
            result.isFontawesome = false;
            result.isFASpinner = false;
            return result;
            break;
    }
    // const cssClass = `class="status-icon ${
    //     result.isMaterial ? 'material-icons ' : ''
    // }${result.isFontawesome ? 'fa fas far ' : ''}${
    //     result.isSuccess ? 'green ' : ''
    // }${result.isWarning ? 'yellow ' : ''}${result.isError ? 'red ' : ''}${
    //     result.isFASpinner ? 'fa-spinner fa-spin ' : ''
    // }"`;
    // result.iconText = `<div class="status-icon"><i ${cssClass}`;
    // if (message) {
    //     result.iconText += ` title='${message}' `;
    // }
    // result.iconText += `>${result.icon}</i></div>`;

    log.verbose({ type: 'getStatusIcon', status, message, result });
    return result;
}
